export default __webpack_public_path__ + "static/media/Town-logo-lt.e3542bcb.svg";